<template>
  <div class="container select-gender">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-wrapper">
          <h1 class="title">Please select your gender</h1>
        </div>
        <div class="title-divider"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="description-wrapper">
          <p>
            Before starting the hearing test we need a few details about your
            gender.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-sm-6 col-lg-6">
        <div @click="selectGender('male')" class="image-wrapper">
          <p>Male</p>
          <img src="/img/male.svg" alt="male"/>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-lg-6">
        <div @click="selectGender('female')" class="image-wrapper">
          <p>Female</p>
          <img src="/img/female.svg" alt="female"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      selectGender(gender) {
        this.$store.commit('setGender', gender)
        this.$router.push('/select-age')
      }
    }
  }
</script>
